import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Icon, Button } from 'Components';
import MobileItemBody from '../MobileItemBody/MobileItemBody';
import './MobileAccordion.css';

const MobileAccordion = props => (
  <div className={`mobile-accordion ${props.active ? 'mobile-accordion--active' : ''}`}>
    <div className="mobile-accordion__container">
      {props.hasPinned &&
      <Button onClick={() => props.onPinClick(props.tableIndex)}>
        <Icon icon={props.data.Pinned ? 'turned_in' : 'turned_in_not'} />
      </Button>}
      <div className="mobile-accordion__container__content">
        <Fragment>
          {props.mobileKeys.fixedkeys.slice(0, 2).map(item => (
            <div key={item}>{props.keyPairs[item]}: {props.data[item]}</div>
          ))}
          {props.mobileKeys.fixedkeys.length >= 4 &&
          <div>
            {props.mobileKeys.fixedkeys.slice(2, 4).map(item => (
              <div key={item}>{props.keyPairs[item] !== '' ? `${props.keyPairs[item]}:` : props.keyPairs[item] } {props.data[item]}</div>
            ))}
          </div>}
        </Fragment>
      </div>
      <Button onClick={props.onExpandClick}>
        <Icon icon={props.active ? 'chevron_left' : 'chevron_right'} rotate={90} />
      </Button>
    </div>
    {
      props.active && <MobileItemBody
        onOptionClick={props.onOptionClick}
        data={props.data}
        tableIndex={props.tableIndex}
        mobileKeys={props.mobileKeys}
        keyPairs={props.keyPairs}
        userName={props.userName}
      />
    }
  </div>
);

MobileAccordion.propTypes = {
  mobileKeys: PropTypes.shape({
    fixedkeys: PropTypes.arrayOf(PropTypes.string),
    translationKey: PropTypes.string,
    code: PropTypes.string,
  }),
  userName: PropTypes.string,
  keyPairs: PropTypes.shape({}),
  data: PropTypes.shape({
    Description: PropTypes.string,
    Pinned: PropTypes.bool,
  }),
  hasPinned: PropTypes.bool,
  tableIndex: PropTypes.number,
  active: PropTypes.bool,
  onPinClick: PropTypes.func,
  onExpandClick: PropTypes.func,
  onOptionClick: PropTypes.func,
};

MobileAccordion.defaultProps = {
  onPinClick: () => null,
  onExpandClick: () => null,
};

export default MobileAccordion;



// WEBPACK FOOTER //
// ./src/components/MobileItemList/MobileAccordion/MobileAccordion.jsx